module.exports = __webpack_public_path__ + "static/media/icon1.73c13e17.png";